import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatGridListModule } from '@angular/material/grid-list';
import { MatTabsModule } from '@angular/material/tabs';

import { GdoPaymentRoutingModule } from './gdo-payment-routing.module';
import { GdoPaymentContainerComponent } from './gdo-payment-container/gdo-payment-container.component';
import { GdoPaymentComponentsComponent } from './gdo-payment-components/gdo-payment-components.component';
import { GdoBraintreeIntegrationComponent } from './gdo-payment-components/gdo-braintree-integration/gdo-braintree-integration.component';
import { GdoPaymentOptionsComponent } from './gdo-payment-components/gdo-payment-options/gdo-payment-options.component';
import { GdoPaymentCardComponent } from './gdo-payment-components/gdo-payment-options/gdo-payment-card/gdo-payment-card.component';
import { GdoRemoveCardConfirmationDialogComponent } from './gdo-payment-components/gdo-payment-options/gdo-remove-card-confirmation-dialog/gdo-remove-card-confirmation-dialog.component';
import { GdoAccountBillingHistoryComponent } from './gdo-payment-components/gdo-account-billing-history/gdo-account-billing-history.component';
import { GdoAdvancedFilterationOptionsComponent } from './gdo-payment-components/gdo-account-billing-history/gdo-advanced-filteration-options/gdo-advanced-filteration-options.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { GdoViewInvoiceComponent } from './gdo-payment-components/gdo-account-billing-history/gdo-view-invoice/gdo-view-invoice.component';
import { GdoSharedModule } from "../../gdo-shared/gdo-shared.module";
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { GdoAddNewPaymentOptionsComponent } from './gdo-payment-components/gdo-payment-options/gdo-add-new-payment-options/gdo-add-new-payment-options.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatRadioModule } from '@angular/material/radio';


@NgModule({
    declarations: [
        GdoPaymentContainerComponent,
        GdoPaymentComponentsComponent,
        GdoBraintreeIntegrationComponent,
        GdoPaymentOptionsComponent,
        GdoPaymentCardComponent,
        GdoRemoveCardConfirmationDialogComponent,
        GdoAccountBillingHistoryComponent,
        GdoAdvancedFilterationOptionsComponent,
        GdoViewInvoiceComponent,
        GdoAddNewPaymentOptionsComponent,
    ],
    imports: [
        CommonModule,
        MatTabsModule,
        MatGridListModule,
        MatFormFieldModule,
        MatDatepickerModule,
        BrowserAnimationsModule,
        MatInputModule,
        ReactiveFormsModule,
        MatIconModule,
        MatPaginatorModule,
        MatTableModule,
        MatCheckboxModule,
        MatButtonModule,
        MatRadioModule,
        GdoPaymentRoutingModule,
        GdoSharedModule
    ],
    exports:[
        GdoPaymentCardComponent
    ]
})
export class GdoPaymentModule { }
